import React from 'react'
import { TextField } from '../fields'
import {
  StepCard,
  TitleContainer,
  StepIndicator,
  SectionTitle,
  Row,
  FieldWrapper,
} from '../styles'

const EmergencyContact = ({ values, setValue, errors }) => (
  <StepCard>
    <TitleContainer>
      <StepIndicator>2</StepIndicator>
      <SectionTitle>Emergency Contact</SectionTitle>
    </TitleContainer>
    <Row>
      <FieldWrapper>
        <TextField
          fullWidth
          label="Name *"
          value={values.emergency_name || ''}
          error={errors.emergency_name}
          onChange={v => setValue('emergency_name', v)}
        />
      </FieldWrapper>
      <FieldWrapper>
        <TextField
          fullWidth
          label="Relationship to Patient *"
          value={values.emergency_relationship || ''}
          error={errors.emergency_relationship}
          onChange={v => setValue('emergency_relationship', v)}
        />
      </FieldWrapper>
      <FieldWrapper>
        <TextField
          fullWidth
          label="Phone Number *"
          value={values.emergency_phone_number || ''}
          error={errors.emergency_phone_number}
          onChange={v => setValue('emergency_phone_number', v)}
        />
      </FieldWrapper>
    </Row>
  </StepCard>
)

export default EmergencyContact
